import { render, staticRenderFns } from "./KycForm.vue?vue&type=template&id=4b363c9c&scoped=true&"
import script from "./KycForm.vue?vue&type=script&lang=js&"
export * from "./KycForm.vue?vue&type=script&lang=js&"
import style0 from "./KycForm.vue?vue&type=style&index=0&id=4b363c9c&scoped=true&lang=css&"
import style1 from "./KycForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b363c9c",
  null
  
)

export default component.exports